import { render, staticRenderFns } from "./LogbookIndex.vue?vue&type=template&id=354180af&scoped=true"
import script from "./LogbookIndex.vue?vue&type=script&lang=js"
export * from "./LogbookIndex.vue?vue&type=script&lang=js"
import style0 from "./LogbookIndex.vue?vue&type=style&index=0&id=354180af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354180af",
  null
  
)

export default component.exports